import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { DELETE_CUSTOM_SOUND } from 'root/src/shared/descriptions/endpoints/endpointIds'

export default (sound, soundType) => dispatch => dispatch(
	apiRequest(DELETE_CUSTOM_SOUND, { soundType, ...sound }),
)
